export default from './button-tooltip';



// WEBPACK FOOTER //
// ./app/components/button-tooltip/index.js